import {
  fileInvestigationReport,
  InvestigationFiling,
} from 'api/bitedb/entities/entityDocuments.service';

export type ReportFilingOutcome = InvestigationFiling;

/**
 * Files a finished investigation's report to the record's Library. The server
 * builds the PDF and files it as prepared by the run's owner; pyapi already
 * asks it to the moment the run ends, so this is the record page's backstop
 * for a run pyapi could not file (or one that finished before it did).
 */
export const fileInvestigationReportToLibrary = ({
  ticketId,
  databaseId,
  databaseEntityId,
}: {
  ticketId: string;
  databaseId: string;
  databaseEntityId: string;
}): Promise<ReportFilingOutcome> =>
  fileInvestigationReport(databaseId, databaseEntityId, ticketId);
